var exports = {
  "DZ": "Heading__wT3EQl",
  "EY": "Text__WZj9jl",
  "Tr": "TimelineListContainer__9wPyJS",
  "ST": "EmptyStateContainer__2Tf5uh",
};

module.exports = exports;
